import React from "react";
import AsyncSelect from "react-select/async";

const AsyncSearchSelect = ({
  loadOptions,
  onChange,
  value,
  placeholder = "Search...",

  // ===== FIX: Correct defaults for our API structure =====
  labelKey = "name",
  valueKey = "id",

  isDisabled = false,
}) => {

  const formatOption = (item) => ({
    label: item[labelKey],
    value: item[valueKey],
    raw: item,
  });

  const promiseOptions = async (inputValue) => {
    const data = await loadOptions(inputValue);
    return data.map(formatOption);
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      loadOptions={promiseOptions}
      onChange={(opt) => onChange(opt?.raw)}
      placeholder={placeholder}
      isDisabled={isDisabled}
      value={
        value
          ? { label: value[labelKey], value: value[valueKey] }
          : null
      }
    />
  );
};

export default AsyncSearchSelect;
